import 'css-chunk:src/applications/ProductFulfillmentApp/components/DetailedProductView.scss';export default {
  "black": "#1a1818",
  "border": "#dadcde",
  "borderLight": "#ececec",
  "bruise": "#70397c",
  "danger": "#d9534f",
  "dangerRed": "#d9534f",
  "darkBlue": "#3996e0",
  "darkBlueHover": "#4fa7ee",
  "darkGreyBlue": "#2e426d",
  "duckEggBlue": "#d6f1df",
  "grey": "#e9e8ea",
  "iceBlue": "#eff5f9",
  "iceBlueHover": "#e6edf2",
  "lightBlue": "#7fd4f4",
  "lightGrey": "#fafafa",
  "maize": "#eacd60",
  "pink": "#ea92af",
  "purpleyGrey": "#8f8d91",
  "purplishPink": "#c6549e",
  "red": "#da3737",
  "sand": "#ffe9d9",
  "success": "#4eb468",
  "successGreen": "#4eb468",
  "warmPink": "#ef5682",
  "watermelon": "#f1515f",
  "white": "#fdfdfd",
  "fontFamily": "system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif",
  "fontSizeXS": "10",
  "fontSizeS": "12",
  "fontSize": "14",
  "fontSizeM": "16",
  "fontSizeL": "20",
  "borderRadius": "0.5rem",
  "borderRadiusMax": "624.9375rem",
  "extraSmallIconSize": "16",
  "smallIconSize": "24",
  "mediumIconSize": "40",
  "largeIconSize": "64",
  "extraLargeIconSize": "128",
  "flex": "_flex_52ynv_157",
  "justify-content-space-between": "_justify-content-space-between_52ynv_161",
  "tabular-nums": "_tabular-nums_52ynv_165",
  "detailedProductView": "_detailedProductView_52ynv_178",
  "variantRow": "_variantRow_52ynv_182",
  "variantDetails": "_variantDetails_52ynv_187",
  "productTitle": "_productTitle_52ynv_190",
  "variantPrice": "_variantPrice_52ynv_194",
  "row": "_row_52ynv_197",
  "priceDetails": "_priceDetails_52ynv_201",
  "quantitySelect": "_quantitySelect_52ynv_206",
  "total": "_total_52ynv_209",
  "grayText": "_grayText_52ynv_212",
  "multiply": "_multiply_52ynv_215",
  "select": "_select_52ynv_218",
  "header": "_header_52ynv_222",
  "image": "_image_52ynv_228",
  "completedIcon": "_completedIcon_52ynv_233",
  "details": "_details_52ynv_236",
  "title": "_title_52ynv_242",
  "subTitle": "_subTitle_52ynv_248",
  "addProductButton": "_addProductButton_52ynv_257",
  "addButton": "_addButton_52ynv_257",
  "labelTitle": "_labelTitle_52ynv_268",
  "labelDescription": "_labelDescription_52ynv_276",
  "searchField": "_searchField_52ynv_284",
  "prefix": "_prefix_52ynv_292",
  "divider": "_divider_52ynv_295",
  "price": "_price_52ynv_201",
  "quantity": "_quantity_52ynv_206",
  "show": "_show_52ynv_1"
};